import { useBootstrapApp } from "./hooks/useBootstrapApp";
import AppContext from "./services/context/AppContext";


const StandAloneApp = () => {
  AppContext.setImpersonationSessionId(null); // standalone never has a session
  const content = useBootstrapApp();
  return content;
};

export default StandAloneApp;